import React from 'react';
import styles from './index.module.scss';
import WithEmbededWrapper from 'component/WithEmbededWrapper';

const CopyRight = () => {
  return <div className={styles.copyRight}>Copyright©{new Date().getFullYear()} 广州视臻信息科技有限公司 保留所有权利</div>;
};

export default WithEmbededWrapper(CopyRight);
